import React from "react";
import { IoAddCircleOutline, IoTrashBinOutline } from "react-icons/io5";
import { TextInput, NumInput, widths, slugify } from "./ui";

const emptyEntrada = () => ({
  id: "",
  nombre: "",
  tipo: "numerico",
  simbolo: "",
  decimales: 0,
  minimo: "",
  maximo: "",
});

const EntradasEditor = ({
  entradas = [],
  onChange,
  emptyMessage = "Sin entradas configuradas. Las entradas son las variables que el dispositivo envía (ej: temperatura, pH, caudal).",
  namePlaceholder = "Ej: Temperatura",
  idPlaceholder = "temp",
  addLabel = "Agregar entrada",
  removeTitle = "Eliminar entrada",
}) => {
  const update = (index, patch) => {
    onChange(entradas.map((e, i) => (i === index ? { ...e, ...patch } : e)));
  };
  const remove = (index) => {
    onChange(entradas.filter((_, i) => i !== index));
  };
  const add = () => {
    onChange([...entradas, emptyEntrada()]);
  };

  return (
    <div className="flex flex-col gap-2">
      {entradas.length === 0 && (
        <p className="text-sm text-gray-500 dark:text-gray-400">{emptyMessage}</p>
      )}

      {entradas.map((entrada, index) => (
        <div
          key={index}
          className="rounded-xl border border-gray-200 bg-white/60 p-2.5 shadow-sm transition-all duration-200 dark:border-white/10 dark:bg-white/5"
        >
          <div className="flex flex-wrap items-end gap-2">
            <TextInput
              label="Nombre"
              value={entrada.nombre}
              onChange={(e) => update(index, { nombre: e.target.value })}
              onBlur={() => {
                if (!entrada.id && entrada.nombre) {
                  update(index, { id: slugify(entrada.nombre) });
                }
              }}
              placeholder={namePlaceholder}
              className={widths.grow}
            />
            <TextInput
              label="ID"
              value={entrada.id}
              onChange={(e) => update(index, { id: slugify(e.target.value) })}
              placeholder={idPlaceholder}
              className={widths.md}
            />
            <TextInput
              label="Símbolo"
              value={entrada.simbolo}
              onChange={(e) => update(index, { simbolo: e.target.value })}
              placeholder="°C"
              className={widths.sm}
            />
            <NumInput
              label="Decimales"
              value={entrada.decimales}
              onChange={(e) => update(index, { decimales: e.target.value })}
              className={widths.sm}
            />
            <NumInput
              label="Mínimo"
              value={entrada.minimo}
              onChange={(e) => update(index, { minimo: e.target.value })}
              className={widths.sm}
            />
            <NumInput
              label="Máximo"
              value={entrada.maximo}
              onChange={(e) => update(index, { maximo: e.target.value })}
              className={widths.sm}
            />
            <button
              type="button"
              onClick={() => remove(index)}
              className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg border-2 border-red-200 text-red-500 transition-all duration-200 hover:-translate-y-0.5 hover:bg-red-500 hover:text-white hover:shadow-md dark:border-red-400/40"
              title={removeTitle}
            >
              <IoTrashBinOutline />
            </button>
          </div>
        </div>
      ))}

      <button
        type="button"
        onClick={add}
        className="flex w-max items-center gap-1 rounded-lg border border-dashed border-gray-300 px-2.5 py-1.5 text-xs font-medium text-gray-600 transition-all duration-200 hover:border-brand-400 hover:text-brand-500 dark:border-white/20 dark:text-gray-300 dark:hover:border-brand-400 dark:hover:text-brand-400"
      >
        <IoAddCircleOutline className="h-3.5 w-3.5" /> {addLabel}
      </button>
    </div>
  );
};

export default EntradasEditor;
